import React, {Component} from "react";
import PropTypes from "prop-types";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {DialogActions} from "@material-ui/core";
import Modal from "../modal/Modal";
import TextareaInput from "../textarea-input/TextareaInput";

/**
 * Reusable XML preview modal used by the eClaim claim submission flow.
 * Renders the XML in a textarea (editable when {@code onXmlChange} is supplied, read-only otherwise)
 * with a Download button — and an optional Submit button — in the footer.
 */
export default class XmlPreviewModal extends Component {

    static defaultProps = {
        readOnly: false,
        submitLabel: "Submit Claims",
        submitting: false,
        contentStyle: {width: "900px", height: "600px"}
    };

    static propTypes = {
        visible: PropTypes.bool.isRequired,
        header: PropTypes.string.isRequired,
        xml: PropTypes.string,
        onXmlChange: PropTypes.func,
        readOnly: PropTypes.bool,
        downloadFilename: PropTypes.string.isRequired,
        onSubmit: PropTypes.func,
        submitLabel: PropTypes.string,
        submitting: PropTypes.bool,
        submitDisabled: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
        contentStyle: PropTypes.object
    };

    handleDownloadClick = () => {
        const xml = this.props.xml || '';
        if (!xml) return;
        const blob = new Blob([xml], {type: 'application/xml'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.props.downloadFilename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    render() {
        const {visible, header, xml, onXmlChange, readOnly, onSubmit, submitLabel,
            submitting, submitDisabled, onClose, contentStyle} = this.props;

        const effectiveSubmitLabel = submitting ? "Submitting..." : submitLabel;
        const effectiveSubmitDisabled = submitting || !xml || !!submitDisabled;

        const downloadButton = (
            <Button variant="primary" onClick={this.handleDownloadClick} disabled={!xml}>
                <FontAwesomeIcon icon="download"/> Download XML
            </Button>
        );

        const submitButton = onSubmit ? (
            <Button variant="success" onClick={onSubmit} disabled={effectiveSubmitDisabled}>
                {effectiveSubmitLabel}
            </Button>
        ) : <span/>;

        return (
            <Modal
                visible={visible}
                header={header}
                closeAction={onClose}
                contentStyle={contentStyle}
                dialogActions={
                    <DialogActions style={{justifyContent: 'space-between'}}>
                        {downloadButton}
                        {submitButton}
                    </DialogActions>
                }
            >
                <div style={{padding: '10px'}}>
                    <TextareaInput
                        style={{width: "100%", height: "500px", fontFamily: "monospace", fontSize: "12px"}}
                        value={xml || ''}
                        readOnly={readOnly}
                        onChange={(value) => { if (onXmlChange) onXmlChange(value); }}
                    />
                </div>
            </Modal>
        );
    }
}
